<template>
  <div>
    <registered-cams-table v-if="currentCameraId === undefined" />
    <registered-cam
      v-else
      :camera-id="currentCameraId"
      @onDelete="dialogDeleteOpen = true"
    />
    <!-- Dialogs -->
    <template>
      <!-- Delete dialog -->
      <clip-dialog-a
        :open="dialogDeleteOpen"
        title="カメラ情報の削除"
        @onClose="closeDialogDelete"
      >
        <div class="registeredCams_dialog-content">
          このカメラ情報を<br />
          完全に削除してもよろしいですか？
        </div>
        <template v-slot:actions>
          <v-btn
            class="registeredCams_dialog-btn registeredCams_dialog-cancel"
            color="text"
            @click="closeDialogDelete"
          >
            キャンセル
          </v-btn>
          <v-spacer />
          <v-btn
            class="registeredCams_dialog-btn registeredCams_dialog-delete"
            color="text"
            @click="handleDeleteOk"
          >
            削除する
          </v-btn>
        </template>
      </clip-dialog-a>
      <!-- ----------------- -->
      <!-- Message dialog -->
      <clip-dialog-message
        :open="!!dialogMessageText"
        :message="dialogMessageText"
        @onClose="closeDialogMessage"
      />
      <!-- ----------------- -->
    </template>
  </div>
</template>

<script>
import RegisteredCam from './RegisteredCam.vue';
import RegisteredCamsTable from './RegisteredCamsTable.vue';
import ClipDialogA from '../../components/dialogs/ClipDialogA.vue';
import ClipDialogMessage from '../../components/dialogs/ClipDialogMessage.vue';

export default {
  name: 'RegisteredCams',
  components: {
    RegisteredCamsTable,
    RegisteredCam,
    ClipDialogA,
    ClipDialogMessage,
  },
  data() {
    return {
      dialogDeleteOpen: false,
      dialogMessageText: null,
    };
  },
  computed: {
    currentCameraId() {
      return this.$route.params.child;
    },
  },
  watch: {
    dialogDeleteOpen(val) {
      val || this.closeDialogDelete();
    },
    dialogMessageText(val) {
      val || this.closeDialogMessage();
    },
  },
  methods: {
    async handleDeleteOk() {
      this.closeDialogDelete();
      this.$router.push({ name: 'settings-info' });
      this.dialogMessageText = 'カメラ情報を削除しました。';
    },
    closeDialogDelete() {
      this.dialogDeleteOpen = false;
    },
    closeDialogMessage() {
      this.dialogMessageText = null;
    },
  },
};
</script>

<style lang="scss">
.registeredCams {
  &_dialog {
    position: relative;
    &-cancel {
      color: #666 !important;
    }
    &-delete {
      color: #eb545b !important;
    }
    &-btn {
      width: 120px;
      font-size: 14px !important;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
    }
    &-content {
      margin: 20px 0;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #666;
    }
  }
}
</style>
